import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, color: PropTypes.oneOf(['text-light', 'primary', 'error', 'success', 'grey', 'action']).isRequired };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'a',
    color: 'primary',
};

class Link extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            color,
        } = this.props;
        return [
            'c-link',
            color === 'error' ? 'c-link--error' : false,
            color === 'action' ? 'c-link--action' : false,
            color === 'text-light' ? 'c-link--text-light' : false,
            color === 'primary' ? 'c-link--primary' : false,
            color === 'success' ? 'c-link--success' : false,
            color === 'white' ? 'c-link--white' : false,
            className,
        ];
    }

}

Link.propTypes = propTypes;

Link.defaultProps = defaultProps;

export default Link;
